import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

// import { useNavigate } from 'react-router-dom';
import * as React from 'react';
// import TextField from '@mui/material/TextField';
// import Autocomplete from '@mui/material/Autocomplete';
// @mui
import {
  Container,
  Typography,
  Stack,
  Button,
  IconButton,
  Card,
  Box,
  Modal
} from '@mui/material';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
// import { UserListToolbar } from '../sections/@dashboard/user';
import Iconify from '../components/iconify';
import { cores } from '../styles/styleUtils';
import AddProposta from './AddProposta'
import EditPropostaLeads from './Leads/EditProposta/EditPropostaLeads';

// api
import { validateUser, getPropostas, getUnoProposta, getLightPropostas, updateProposta, deleteProposta, GetDadosHomeEngenharia, GetDadosHomeMontagem, updateChamado } from './api';
import config from '../config.json';
import PopoverFiltro from './PopoverFiltro';
import ModalLoading from './ModalLoading';
import ModalConfirmacao from './ModalConfirmacao';


const sxCard = {
  py: 1,
  boxShadow: 3,
  textAlign: 'center',
  background: `linear-gradient(180deg, ${cores.painelTopo} 0%, ${cores.painelBase} 100%)`,
  borderTop: `4px solid ${cores.laranja}`,
  borderRadius: 2,
  minHeight: 50,
  display: 'flex',
  flexDirection: 'column',
  width: 200
};

const CardItem = ({ nome, valor }) => {
  return (
    <Card sx={sxCard}>
      <Typography
        variant="subtitle2"
        sx={{
          color: '#bdbdbd',
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          fontSize: 11
        }}
      >
        {nome}
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{
          color: cores.textoClaro,
          fontWeight: 700,
          '@media (max-width: 600px)': {
            fontSize: 6,
          },
          marginTop: 'auto',
        }}
      >
        {valor}
      </Typography>
    </Card>
  );
};


// ----------------------------------------------------------------------

export default function Propostas() {
  const currentLocation = useLocation(); // Renomeie para evitar conflitos
  // const [propostas, setPropostas] = useState(mock.propostas)
  const [propostas, setPropostas] = useState([])
  const [modalLoading, setModalLoading] = useState(false)

  const [dados, setDados] = useState([]);

  // useEffect(() => { fGetPropostas() }, []);
  const fGetPropostas = async (filtro) => {
    try {
      // Na Engenharia, as propostas de produtos e de serviços são
      // retornadas por filtros diferentes na API. Buscamos as duas e
      // unificamos o resultado para exibir tudo na mesma tabela.
      if (currentLocation.pathname === '/propostas2') {
        const filtroBase = { ...filtro };

        // Evita conflito entre os dois tipos de consulta.
        delete filtroBase.engenharia;
        delete filtroBase.servicos;

        const [propostasEngenharia, propostasServicos] = await Promise.all([
          getLightPropostas({
            ...filtroBase,
            engenharia: true,
          }),
          getLightPropostas({
            ...filtroBase,
            servicos: true,
          }),
        ]);

        const todasPropostas = [
          ...(propostasEngenharia || []),
          ...(propostasServicos || []),
        ];

        // Proteção contra eventual duplicidade entre as consultas.
        const propostasUnicas = Array.from(
          new Map(todasPropostas.map((proposta) => [proposta._id, proposta])).values()
        );

        setPropostas(propostasUnicas);
        return;
      }

      // Comercial e Montagem mantêm o comportamento original.
      const dados = await getLightPropostas(filtro);
      setPropostas(dados || []);
    } catch (error) {
      window.alert("Erro ao consultar banco de dados")
      console.error('Erro ao buscar dados da API:', error);
    }
  }

  // Valida usuario
  const navigate = useNavigate();
  useEffect(() => {
    validateuser()
  }, [])
  const validateuser = async () => {
    const teste = await validateUser();
    if (!teste.ok) {
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {}
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente')
      return
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario
  }
  // -------------
  // Outras funcoes e declaracoes
  // ---------------------
  // Modal
  const [open, setOpen] = React.useState(false);
  const [openLead, setOpenLead] = React.useState(false);
  const [produto, setProduto] = React.useState(null);
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'))
  const [modalConfirmacaoDelete, setModalConfirmacaoDelete] = useState(false)



  const handleOpen = (row, index) => {
    setProduto(null)
    setOpen(true)
  };

  const handleDoubleClickTable = async (row, index) => {

    const proposta = await getUnoProposta(row)
    const rowCopy = JSON.parse(JSON.stringify({ ...proposta, index }));

    setProduto(rowCopy);
    if (proposta.fluxo.id === 10) {
      setOpenLead(true)
      return;
    }
    setOpen(true);
  };


  const handleClose = () => {
    setOpen(false)
    setOpenLead(false)
    setProduto(null)
    setModalLoading(false)
  };

  const onConfirmHandler = async (proposta, anexo) => {
    setModalLoading(true)
    try {
      const [result1, result2] = await Promise.all([
        updateProposta(proposta, anexo),
        // updateAnexo(anexo,proposta),
      ]);


      setProduto(null);
      handleClose();

      // window.alert(result1.msg);

      fGetPropostas(filtro);
      fetchDataEngenharia(filtro)
      fetchDataMontagem(filtro)
    } catch (error) {
      console.error('Erro ao atualizar as coleções:', error);
      // Lidar com erros, se necessário
    }
    setModalLoading(false)
  };


  const onSaveHandler = async (proposta, anexo) => {
    console.log('onSave result:', proposta?.acrescimoAceito);
    setModalLoading(true);
    try {
      const result = await updateProposta(proposta, anexo);
        if (result?.data) {
        // Preservar acrescimoAceito pois o banco pode não ter este campo
        setProduto({ ...result.data, acrescimoAceito: proposta.acrescimoAceito });
      } else {
        setProduto({ ...proposta });
      }
      fGetPropostas(filtro);
    } catch (error) {
      console.error('Erro ao salvar:', error);
    }
    setModalLoading(false);
  };

  const onConfirmNewSale = async (data) => {
    setModalLoading(true);
    const response = await updateProposta(data);

    setModalLoading(false);
    handleClose();
    fGetPropostas(filtro);
    if (response && response.data) {
      if (response.data.finalizadoLead?.nome === 'Lead Qualificado') {
        setProduto({ ...response.data });
        setOpen(true);
      }
    }
  };


  // Filtro ----
  const dataAtual = new Date();
  const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
  const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
  // Identifica perfil do usuário logado
  const isSupervisor = usuarioLogado?.supervisor;
  const isMontador   = usuarioLogado?.montador;
  const isEngenheiro = !isSupervisor && !isMontador && usuarioLogado?.modulos?.some(m => m.id === 2 && m.ativo);

  const emptyFiltro = {
    usuarioLogado,
    datainicial: primeiroDiaDoMes,
    datafinal: ultimoDiaDoMes,
    ...(currentLocation.pathname === '/propostas2' && { engenharia: true }),
    // No módulo Engenharia: engenheiro visualiza apenas as propostas alocadas a ele.
    ...(currentLocation.pathname === '/propostas2' && isEngenheiro && { responsavel: usuarioLogado }),
    ...(currentLocation.pathname === '/propostas3' && { montagem: true }),
    // No módulo Montagem: engenheiro filtra por responsavel, montador por montador
    ...(currentLocation.pathname === '/propostas3' && isEngenheiro && { responsavel: usuarioLogado }),
    ...(currentLocation.pathname === '/propostas3' && isMontador   && { montador: usuarioLogado }),
  }
  const [filtro, setFiltro] = useState({ ...emptyFiltro });
  const [openFiltro, setOpenFiltro] = useState(null)

  const onCloseFiltro = () => {
    setOpenFiltro(null)
  }

  const limparFiltro = () => {
    setFiltro({ ...emptyFiltro })
    setOpenFiltro(null)
  }

  const onConfirmFiltro = (filtroPopover) => {
    setFiltro(filtroPopover)
    setOpenFiltro(null)
  }

  useEffect(() => {
    fGetPropostas(filtro)
    fetchDataEngenharia(filtro)
    fetchDataMontagem(filtro)
  }, [filtro])
  // Filtro ----

  const fetchDataEngenharia = async () => {
    if (currentLocation.pathname === '/propostas2') {
      const result = await GetDadosHomeEngenharia(filtro);
      setDados(result);
    }
  };

  const fetchDataMontagem = async () => {
    if (currentLocation.pathname === '/propostas3') {
      const result = await GetDadosHomeMontagem(filtro);
      setDados(result);
    }
  };

  const handleDeleteClick = (row) => {
    setProduto(row);
    setModalConfirmacaoDelete(true);
  };


  const closeModalConfirmacaDelete = () => {
    setModalConfirmacaoDelete(false)
    setProduto(null)
  }

  const confirmDelete = async () => {
    setModalLoading(true)
    await deleteProposta(produto)
    closeModalConfirmacaDelete()
    fGetPropostas(filtro)
    fetchDataEngenharia(filtro)
    fetchDataMontagem(filtro)
    setProduto(null)
    setModalLoading(false)
  }

  // ----------------------

  return (
    <>
      <Helmet>
        <title> Propostas </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography variant="h4" sx={{ mb: 5 }}>
            {currentLocation.pathname === '/propostas2' ? 'Engenharia' : currentLocation.pathname === '/propostas3' ? 'Instalação' : 'Propostas'}
          </Typography>

          <Button onClick={(e) => setOpenFiltro(e.currentTarget)} variant="contained" startIcon={<Iconify icon="eva:search-fill" />} sx={{ height: 50, minWidth: 100, backgroundColor: 'MediumSeaGreen', marginLeft: 'auto', '&:hover': { backgroundColor: 'SeaGreen' } }}>
            Filtros
          </Button>

          {
            currentLocation.pathname === '/propostas2' || currentLocation.pathname === '/propostas3' ? null :
              <Button variant="contained" onClick={handleOpen} startIcon={<Iconify icon="zondicons:add-solid" />} sx={{ height: 50, minWidth: 100, marginLeft: 1 }}>
                Adicionar
              </Button>
          }

        </Stack>

        {/** Cards de Engenharia e Montagem */}
        <Stack direction={'row'} justifyContent={'center'} gap={0.5}>
          {currentLocation.pathname !== '/propostas' &&
            dados.map(etapa => {
              return <CardItem nome={etapa.etapa} valor={etapa.quantidade} />
            })
          }
        </Stack>



        {/* ------------ Tabela ------------ */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Cliente</TableCell>
                {/* NOVO (deployment Marcki): identifica a unidade/filial do
                    cliente final sem precisar abrir a proposta — útil para
                    clientes recorrentes com múltiplos pontos de contato. */}
                <TableCell align="left">Referência/Unidade</TableCell>
                <TableCell align="left">Usuário</TableCell>
                <TableCell align="left">Abertura</TableCell>
                <TableCell align="center">Produto</TableCell>
                <TableCell align="center">Data</TableCell>
                <TableCell align="center">Valor</TableCell>
                {currentLocation.pathname === '/propostas3' && <TableCell align="center">Montagem</TableCell>}
                <TableCell align="center">Fluxo</TableCell>
                <TableCell align="center">Etapa</TableCell>
                {usuarioLogado.supervisor && <TableCell align="center"> </TableCell>}
              </TableRow>
            </TableHead>

            <TableBody>
              {propostas.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    '&:hover': { backgroundColor: 'Azure' },
                    ...(row.finalizado?.nome === 'Rejeitado' && {
                      color: 'red',
                      textDecoration: 'line-through',
                    }),
                  }}
                  onDoubleClick={() => handleDoubleClickTable(row, index)}
                >
                  <TableCell align="left">{row.cliente?.nome}</TableCell>
                  <TableCell align="left">{row.referenciaCliente || '—'}</TableCell>
                  <TableCell align="left">{row.user?.nome}</TableCell>
                  <TableCell align="left">{row.user2?.nome}</TableCell>
                  <TableCell align="center">{row.produto?.nome}</TableCell>
                  <TableCell align="center">{new Date(row.data).toLocaleDateString()}</TableCell>
                  <TableCell align="center">{row.valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
                  {currentLocation.pathname === '/propostas3' && <TableCell align="center">{row.valormontagem?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>}
                  <TableCell align="center">
                    {row.fluxo?.id === 1 && row.produto?.nome === 'Personalizado'
                      ? 'Proposta Personalizada'
                      : row.fluxo?.id === 1 && (row.produto?.nome === 'Serviços' || row.produto?.nome === 'Proposta de Serviços')
                      ? 'Proposta de Serviços'
                      : row.fluxo?.nome}
                  </TableCell>
                  <TableCell align="center" sx={{ backgroundColor: row.etapa?.color, borderRadius: 3 }}><strong>{row.etapa?.nome}</strong></TableCell>
                  {/* Ícone de exclusão visível apenas para supervisores */}
                  {usuarioLogado.supervisor && (
                    <TableCell align="center">
                      <IconButton onClick={() => handleDeleteClick(row)}>
                        <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                      </IconButton>
                    </TableCell>
                  )}

                </TableRow>

              ))}
              <TableRow>
                <TableCell align="left" colSpan={3}>
                  <strong>Total</strong>
                </TableCell>
                <TableCell align="center" colSpan={2}>
                  Quantidade: <strong>{propostas.length}</strong>
                </TableCell>
                <TableCell align="center" >
                  <strong>
                    {propostas
                      .reduce((acc, curr) => acc + (curr.valor || 0), 0)
                      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </strong>
                </TableCell>
                <TableCell align="center" >
                  <strong>
                    {propostas
                      .reduce((acc, curr) => acc + (curr.valormontagem || 0), 0)
                      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </strong>
                </TableCell>


              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>


      </Container>

      {
        open && <AddProposta open={open} proposta={produto} onClose={handleClose} onConfirm={onConfirmHandler} onSave={onSaveHandler} />
      }
      {
        openLead &&
        <Modal
          open={openLead}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <EditPropostaLeads open={openLead} onClose={handleClose} proposta={produto} onConfirm={onConfirmNewSale} />
        </Modal>
      }

      {
        openFiltro ?
          <PopoverFiltro filtro={filtro} open={openFiltro} onClose={onCloseFiltro} onLimpar={limparFiltro} onConfirm={onConfirmFiltro} />
          : null
      }
      {/* Modal Loading */}
      {modalLoading && <ModalLoading open={modalLoading} />}

      {
        modalConfirmacaoDelete ? <ModalConfirmacao title={"Tem certeza que deseja excluir essa proposta?"} subtitle={`${produto.cliente?.nome} - ${new Date(produto.data).toLocaleDateString()} - ${parseFloat(produto.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
          open={modalConfirmacaoDelete} onClose={closeModalConfirmacaDelete} onConfirm={confirmDelete} /> : null
      }

    </>
  );
}